import { getState } from './state';
import { InitializationStatus } from '../../types';
import { createSelector } from 'reselect';

const getInitializationStoreSlice = createSelector([getState], ncSlice => {
  return ncSlice.initialization ?? {};
});

export const getIsReduxInitialized = createSelector(
  [getInitializationStoreSlice],
  initSlice => initSlice.isReduxInitialized === InitializationStatus.Success
);

export const getInitializationStatus = createSelector(
  [getInitializationStoreSlice],
  initSlice => {
    const initializationStatuses = Object.values(initSlice);
    if (
      initializationStatuses.length === 0 ||
      initializationStatuses.includes(InitializationStatus.Initializing)
    ) {
      return InitializationStatus.Initializing;
    } else if (initializationStatuses.includes(InitializationStatus.Failure)) {
      return InitializationStatus.Failure;
    }

    return InitializationStatus.Success;
  }
);

export const getIsOnline = createSelector(
  [getInitializationStoreSlice],
  initSlice =>
    initSlice.online ??
    (initSlice.areTranslationsInitialized === InitializationStatus.Success &&
      initSlice.isReduxInitialized === InitializationStatus.Success)
);

export const getAuthInitializationAttempted = createSelector(
  [getInitializationStoreSlice],
  initSlice => initSlice.authInitializationAttempted ?? false
);
